module.exports = __webpack_public_path__ + "img/bul_feature02.9ffa55bf.svg";